import React from 'react'
import * as  Style from './style';
import * as Images from '../../../../images';

const LeftPart = () => {
    return (
        <Style.LeftSection>
            <Style.ImgEdit src={Images.supImg} />
        </Style.LeftSection>
    )
}

export default LeftPart